import moment from 'moment'
const DATE_FORMAT = 'YYYY-MM-DD'

const sortingByString = (list: any[], type: string, name: string): any[] => {
  const options = {
    sensitivity: 'base',
  }
  if (type === 'asc') {
    list.sort((a, b) => {
      return `${a[name]}`.localeCompare(`${b[name]}`, 'en', options)
    })
  } else {
    list.sort((a, b) => {
      return `${b[name]}`.localeCompare(`${a[name]}`, 'en', options)
    })
  }
  return list
}

const sortingByStatus = (list: any[], type: string, name: string): any[] => {
  const status: any = {
    INIT: 1,
    PEND: 2,
    APPV: 3,
    REJT: 4,
  }

  if (type === 'asc') {
    list.sort((a, b) => {
      const aVal = status[`${a[name]}`] || 0
      const bVal = status[`${b[name]}`] || 0
      return bVal - aVal
    })
  } else {
    list.sort((a, b) => {
      const aVal = status[`${a[name]}`] || 0
      const bVal = status[`${b[name]}`] || 0
      return aVal - bVal
    })
  }

  return list
}

export const sortingByNumber = (list: any[], type: string, name: keyof any): any[] => {
  if (type === 'asc') {
    list.sort((a, b) => {
      return Number(a[name] || 0) - Number(b[name] || 0)
    })
  } else {
    list.sort((a, b) => {
      return Number(b[name] || 0) - Number(a[name] || 0)
    })
  }

  return list
}

export const getUnixTime = (val: any) => {
  return val ? moment(val, DATE_FORMAT).unix() : 0
}

const sortingByDate = (list: any[], type: string, name: string): any[] => {
  if (type === 'asc') {
    list.sort((a, b) => {
      const unixA = getUnixTime(a[name])
      const unixB = getUnixTime(b[name])

      return unixA - unixB
    })
  } else {
    list.sort((a, b) => {
      const unixA = getUnixTime(a[name])
      const unixB = getUnixTime(b[name])

      return unixB - unixA
    })
  }

  return list
}

const sortingByCountDate = (list: any[], type: string, name: string): any[] => {
  const today = moment()
  if (type === 'asc') {
    list.sort((a, b) => {
      const unixA = moment(a[name], DATE_FORMAT).diff(today, 'days')
      const unixB = moment(b[name], DATE_FORMAT).diff(today, 'days')

      return unixA - unixB
    })
  } else {
    list.sort((a, b) => {
      const unixA = moment(a[name], DATE_FORMAT).diff(today, 'days')
      const unixB = moment(b[name], DATE_FORMAT).diff(today, 'days')

      return unixB - unixA
    })
  }

  return list
}

export const getParamsForSorting = (params: string[], type: string): any[] => {
  const sortBy = [] as any
  params.map(param => {
    sortBy.push({
      prop: param,
      direction: type === 'asc' ? 1 : -1,
    })
  })
  return sortBy
}

export const sortingByMultiParams = (list: any[], type: string, params: string[]): any[] => {
  const sortBy = getParamsForSorting(params, type)
  const sortResult = list.sort(function(a, b) {
    let i = 0,
      result = 0
    while (i < sortBy.length && result === 0) {
      result =
        sortBy[i].direction *
        (a[sortBy[i].prop].toString() < b[sortBy[i].prop].toString()
          ? -1
          : a[sortBy[i].prop].toString() > b[sortBy[i].prop].toString()
          ? 1
          : 0)
      i++
    }
    return result
  })
  return sortResult
}

export const sortingList = (list: any[], type: string, name: string, typeOfName: string): any[] => {
  try {
    let newList: any[] = list
    switch (typeOfName) {
      case 'string':
        newList = sortingByString(list, type, name)
        break
      case 'date':
        newList = sortingByDate(list, type, name)
        break
      case 'count_date':
        newList = sortingByCountDate(list, type, name)
        break
      case 'number':
        newList = sortingByNumber(list, type, name)
        break
      case 'status':
        newList = sortingByStatus(list, type, name)
        break
      case 'iso_date':
        newList = sortingByISODate(list, type, name)
        break
      default:
    }

    return newList
  } catch (e) {
    return list
  }
}

const convertISODateToString = (isoDate: any) => {
  return moment(isoDate)
    .utc()
    .format(DATE_FORMAT)
}

const sortingByISODate = (list: any[], type: string, name: string): any[] => {
  if (type === 'asc') {
    list.sort((a, b) => {
      const unixA = moment(convertISODateToString(a[name]), DATE_FORMAT).unix()
      const unixB = moment(convertISODateToString(b[name]), DATE_FORMAT).unix()
      return unixA - unixB
    })
  } else {
    list.sort((a, b) => {
      const unixA = moment(convertISODateToString(a[name]), DATE_FORMAT).unix()
      const unixB = moment(convertISODateToString(b[name]), DATE_FORMAT).unix()
      return unixB - unixA
    })
  }

  return list
}
